import { createReducer, on, Action } from '@ngrx/store';
import { FormGroupState } from '@shared/models/common';
import { MesRemboursementsSearchFormActions } from '@features/mes-remboursements/store/search/search.actions';
import { MesRemboursemntsRechercheForm as MesRemboursementsRechercheForm } from '@features/mes-remboursements/features/mes-remboursements-recherche/models/remboursement-recherche-form';
import { CategoryFolderEnum } from '@shared/enums/categorie.enum';

export const REMBOURSEMENT_RECHERCHE_FEATURE_KEY = 'recherche';

export interface MesRemboursementsRechercheFormState extends FormGroupState<MesRemboursementsRechercheForm> {
  categorieDossier: CategoryFolderEnum;
  querySiret: string;
  displayDispositif: boolean;
  displayStatus: boolean;
  displayNumeroDossier: boolean;
  displaySiret: boolean;
  resetDone: boolean;
  keepHistory: boolean;
}

export const initialState: MesRemboursementsRechercheFormState = {
  querySiret: '',
  value: new MesRemboursementsRechercheForm(),
  categorieDossier: CategoryFolderEnum.TOUTES,
  checkingForm: false,
  isValid: false,
  errorMessage: null,
  errors: [],
  displayDispositif: false,
  displayStatus: false,
  displayNumeroDossier: false,
  displaySiret: false,
  resetDone: true,
  keepHistory: true
};

export const mesRemboursementsRechercheReducers = createReducer(
  initialState,
  on(MesRemboursementsSearchFormActions.updateSearchForm, (state, { form }) => ({
    ...state,
    value: form,
  })),

  on(MesRemboursementsSearchFormActions.updateCategorieDossier, (state, { categorieDossier }) => ({
    ...state,
    categorieDossier,
  })),
  on(MesRemboursementsSearchFormActions.resetSearchForm, (state) => ({
    ...state,
    querySiret: '',
    value: new MesRemboursementsRechercheForm(),
  })),
  on(MesRemboursementsSearchFormActions.searchSiretFromQuery, (state, { querySiret }) => ({
    ...state,
    querySiret,
  })),
  on(MesRemboursementsSearchFormActions.searchSiretFromQueryFailure, (state, { validationErrors }) => ({
    ...state,
    errors: validationErrors
  })),
  on(MesRemboursementsSearchFormActions.searchSiretFromQuerySucces, (state => ({
    ...state,
    errors: []
  }))),

  on(MesRemboursementsSearchFormActions.updateDispositif, (state, { typeDispositif, typeDispositifLibelle }) => ({
    ...state,
    value: {
      ...state.value,
      typeDispositif,
      typeDispositifLibelle
    },
  })),
  on(MesRemboursementsSearchFormActions.displayDispositif, (state, { value }) => ({
    ...state,
    displayDispositif: value,
  })),
  on(MesRemboursementsSearchFormActions.updateStatus, (state, { status, statusLibelle }) => ({
    ...state,
    value: {
      ...state.value,
      statutDossier: status,
      statutDossierLabel: statusLibelle
    },
  })),
  on(MesRemboursementsSearchFormActions.displayStatus, (state, { value }) => ({
    ...state,
    displayStatus: value,
  })),
  on(MesRemboursementsSearchFormActions.updateNumeroDossier, (state, { numDossier }) => ({
    ...state,
    value: {
      ...state.value,
      numeroDossier: numDossier,
    },
  })),
  on(MesRemboursementsSearchFormActions.displayNumeroDossier, (state, { value }) => ({
    ...state,
    displayNumeroDossier: value,
  })),
  on(MesRemboursementsSearchFormActions.updateSiret, (state, { siret }) => ({
    ...state,
    value: {
      ...state.value,
      siret: siret,
      rechercheBySiret: true
    },
  })),
  on(MesRemboursementsSearchFormActions.displaySiret, (state, { value }) => ({
    ...state,
    displaySiret: value,
  })),
  on(MesRemboursementsSearchFormActions.resetDone, (state, { resetDone }) => ({
    ...state,
    resetDone,
  })),
  on(MesRemboursementsSearchFormActions.updateKeepHistory, (state, { value }) => ({
    ...state,
    keepHistory: value,
  }))
);


export const reducer = (
  state: MesRemboursementsRechercheFormState | undefined,
  action: Action,
): MesRemboursementsRechercheFormState => mesRemboursementsRechercheReducers(state, action);
